/* eslint-disable react/jsx-boolean-value */
/* eslint-disable  @typescript-eslint/no-floating-promises */
/* eslint-disable  react-hooks/exhaustive-deps */
/* eslint-disable  import/order */
/* eslint-disable import/no-named-as-default */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cloneDeep, assign as loadshAssign } from 'lodash';

import FormDrawer from '~/components/FormDrawer';
import { ApplicationPayload } from '~/types/ApplicationPayload';
import { getContactDataFromUpdatedList, getUpdatedShareholderData } from '~/utils/contacts';
import { useMutateContactsApi } from '~/controllers/contacts';
import buildNamePath from '~/utils/buildNamePath';
import { Shareholders } from '~/types/Shareholders';
import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';

import IndividualForm, { formName } from './IndividualForm';
import { shareholdersKey } from '.';

interface Props extends Partial<FormItemInjectedProps<Shareholders>> {
  uid: string;
  onClose: () => void;
  refetchContacts: () => void;
  setSourceOfEditing: any;
}

const BeneficialOwnerEdit: React.FC<Props> = (props) => {
  const { uid, onClose, refetchContacts, setSourceOfEditing } = props;
  const { value, onChange } = props as FormItemInjectedProps<Shareholders>;
  const [updatedData, setUpdatedData] = useState<any>({});
  const [rerender, setRerender] = useState<any>(false);
  const { t } = useTranslation('fillApplication');
  const contactsMutation = useMutateContactsApi();
  const shareholdersFormState = { shareholders: value };
  const currentIndex = value?.beneficialOwners?.findIndex((item) => item?.data?.uid === uid) ?? 0;

  const onFinish = async (newValues: ApplicationPayload | any) => {
    const updatedBeneficialOwner = newValues?.shareholders?.beneficialOwners[currentIndex];
    const beneficialOwners: any = value?.beneficialOwners;
    const updatedShareholdersData = {
      ...value,
      beneficialOwners: beneficialOwners?.toSpliced(currentIndex, 1, updatedBeneficialOwner),
    };

    const updatedContactFromContactsList = await getContactDataFromUpdatedList(updatedBeneficialOwner);
    const updatedContactListIndividual = loadshAssign(updatedContactFromContactsList, updatedBeneficialOwner.data);
    contactsMutation.mutate(updatedContactListIndividual);

    onChange(updatedShareholdersData);
    refetchContacts();
    setSourceOfEditing('shareholder');
    setRerender((prev: any) => !prev);
    onClose();
  };

  useEffect(() => {
    getUpdatedShareholderData({ existedData: { ...shareholdersFormState[shareholdersKey] } }).then((data) => {
      setUpdatedData({ shareholders: { ...data } });
    });
  }, [JSON.stringify(shareholdersFormState), shareholdersKey, rerender]);

  return (
    <FormDrawer
      id="beneficialOwnerEditDrawer"
      open={!!uid}
      onClose={onClose}
      title={t('Edit beneficial owner')}
      formName={formName}
    >
      <IndividualForm
        onFinish={onFinish}
        n={buildNamePath([shareholdersKey, 'beneficialOwners', currentIndex])}
        initialValues={updatedData}
        shareholderType="BENEFICIAL_OWNER"
        edit
      />
    </FormDrawer>
  );
};

export default BeneficialOwnerEdit;
